module.exports = __webpack_public_path__ + "Flag-705.7d8016c31cd04cb263f3b8d932208dbe.svg";